import styled, { css } from 'styled-components';
import { IconButton } from '@mui/material';

import colors from '../../../../styles/colors';

const ToggleButton = styled(IconButton)`
  && {
    background-color: ${colors.shades.gamma4};

    &:hover {
      background-color: ${colors.shades.gamma3};
    }

    svg {
      color: ${colors.shades.gamma2};
    }

    ${({ $size }) => {
    switch ($size) {
      case 'small':
        return css`
          width: 28px;
          height: 28px;
          padding: 2px;
        `;
      case 'medium':
      default:
        return css`
          width: 32px;
          height: 32px;
          padding: 4px;
        `;
    }
  }}
  }
`;

export default ToggleButton;
